export default from './avatar';



// WEBPACK FOOTER //
// ./app/components/avatar/index.js